import axios from 'axios';

/**
 * Global axios interceptor.
 * Whenever any API call returns 401, we treat the session as expired:
 *   - Clear the stored token
 *   - Redirect to /login with a flag so we can show "Session expired" toast
 *
 * This prevents the frontend from sitting in a 401-loop after token expiry
 * (e.g., long-running tabs polling /autoguard/status every 5s).
 */
let isHandling401 = false;

export function setupAxiosInterceptors() {
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error.response?.status;
      const url = error.config?.url || '';
      // Don't trigger on:
      //   * /auth/me, /auth/login — AuthContext handles those gracefully.
      //   * /api/google/* — 401 here means "Google account not connected /
      //     OAuth token expired", NOT that Sortilize's own session expired.
      //     Treating it as a session-kill logs the user out the moment they
      //     visit the SEO page without Google connected.
      const isAuthCheck = url.includes('/api/auth/me') || url.includes('/api/auth/login');
      const isGoogleEndpoint = url.includes('/api/google/');
      if (status === 401 && !isAuthCheck && !isGoogleEndpoint && !isHandling401) {
        isHandling401 = true;
        localStorage.removeItem('token');
        // Avoid hard redirect during active form submits — give a tick for state cleanup
        setTimeout(() => {
          if (window.location.pathname !== '/login' && !window.location.pathname.match(/^\/(pricing|signup|onboarding)?$/)) {
            window.location.href = '/login?reason=expired';
          }
          isHandling401 = false;
        }, 150);
      }
      return Promise.reject(error);
    },
  );
}
